import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ServiceUnavailableError = ({
    onCancel,
    onRetry,
    actionBarClass,
}) => (
    <div>
        <div className="bs-loginError">
            <div className="bs-loginError__title">Service Unavailable</div>
            <div className="bs-loginError__message">
                <span>The service is temporarily unavailable.</span>
                <span>Please try again later.</span>
            </div>
        </div>
        <div className={classNames('bs-actionBar', 'bs-section', actionBarClass)}>
            <span
                role="button"
                tabIndex={0}
                onClick={onCancel}
                className={`
                    bs-actionBar__half
                    bs-actionBar__link
                    bs-actionBar__link_danger
                `}
            >
                <span>Cancel</span>
            </span>
            <button
                onClick={onRetry}
                className={`
                    bs-btn
                    bs-btn_major
                    bs-actionBar__half
                    bs-actionBar__button
                    bs-actionBar__button_2XL
                `}
            >
                <span>Retry</span>
            </button>
        </div>
    </div>
);

ServiceUnavailableError.defaultProps = {
    actionBarClass: '',
};

ServiceUnavailableError.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onRetry: PropTypes.func.isRequired,
    actionBarClass: PropTypes.string,
};

export default ServiceUnavailableError;



// WEBPACK FOOTER //
// /src/js/common/loginPage/components/ServiceUnavailableError.jsx